import React, { useState } from "react";
import "./CubicBox.css";
import { CubicBoxData } from "./CubicBoxData.jsx";

const CubicBox = () => {
  const [expandedId, setExpandedId] = useState(null);

  const handleBoxClick = (id) => {
    // Toggle the expansion state for the clicked box
    setExpandedId((prevId) => (prevId === id ? null : id));
  };

  return (
    <div className="box-container">
      <div className="cube-box-wrap">
        {CubicBoxData.map((item) => {
          const isExpanded = expandedId === item.id;
          return (
            <div key={item.id} className="cube-box-row">
              <div className="box-shadow top"></div>
              <div className="box-shadow left"></div>
              <div className="main-box" onClick={() => handleBoxClick(item.id)}>
                <div className="main-box-wrap">
                  <div className="main-box-row row1">
                    <div className="icon-hold-box">
                      <img src={item.icon} alt="tracks icon" className="box-icon" />
                    </div>
                  </div>
                  <div className="main-box-row row2">
                    <div className="content-hold-box">
                      <h3>{item.title}</h3>
                    </div>
                  </div>
                </div>
                <div
                  className={`extra-content-box ${
                    isExpanded ? "expanded" : ""
                  }`}
                >
                  <p>{item.para}</p>
                  <div
                    className="lists-box"
                    dangerouslySetInnerHTML={{ __html: item.lists }}
                  ></div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CubicBox;
